<template>
  <div class="tw:mt-6 tw:bg-white tw:border tw:border-gray-300 tw:rounded-xl tw:px-5 tw:py-4">
    <div class="tw:flex tw:items-center tw:py-1">
      <p class="tw:text-xl tw:font-bold">{{ $t('ri_rate_trends_header') }}</p>
      <UiTooltip
        theme="customdarkwithpadding"
        tooltip-position="top"
        :label="$t('ri_rate_trends_tooltip')"
        class="tw:cursor-pointer tw:ml-1"
      >
        <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-[22px] tw:w-[22px] tw:ml-1" />
      </UiTooltip>
    </div>
    <div v-if="isLoading" class="tw:animate-pulse tw:space-y-3 tw:mt-4 tw:mb-2">
      <div class="tw:h-48 tw:bg-gray-100 tw:rounded tw:w-full"></div>
    </div>
    <GraphContainer
      v-else
      :competitors="competitors"
      :series="series"
      :categories="categories"
      :days="days"
      :filters="filters"
      :currency="currency"
      @select-day="onSelectDay"
      container="price-trend-chart"
    />
  </div>
</template>

<script setup>
import { useSessionValues } from '@/composables/useSessionValues'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import GraphContainer from '@/components/rateInsights/rates/GraphContainer.vue'

const emit = defineEmits(['select-day'])

function onSelectDay(timestamp) {
  emit('select-day', timestamp)
}

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  series: {
    type: Array,
    default: () => [],
  },
  categories: {
    type: Object,
    default: () => ({}),
  },
  days: {
    type: Object,
    default: () => ({}),
  },
  competitors: {
    type: Object,
    default: () => ({}),
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
})

const { currency } = useSessionValues()
</script>
